import React, { useEffect, useState } from "react"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import {
  makeSelectDimensionsDrillDown,
  makeSelectDivisions,
  makeSelectIsLoadingDimensions,
  makeSelectShowDimensionBenchmark,
} from "./selectors"
import { getDimensionsWatcher } from "./actions"

import "../../../Reports/components/ClimateMeasurement/components/WidgetResultByDimensionAmbassador/index.less"

import {
  LOCAL_CHECKBOX_EXCLUDE,
  LOCAL_ISOLATED_METRICS,
} from "../../../utils/storage"
import {
  searchItemInTree,
  searchTree,
  truncateText,
  validate,
} from "../../../utils/functions"
import { Spin } from "antd"
import ResultByDimensionChart from "../../../Reports/components/ReChart/ResultByDimensionChart"
import { Link } from "react-router-dom"
import PopoverImpact from "../../../Reports/components/PopoverImpact"
import { QuestionCircleFilled } from "@ant-design/icons"
import { loadTexts } from "../../../utils/i18n"

export function WidgetResultByDimensionAmbassador(props) {
  const intlWidgetResultByDimension = loadTexts("reports_general_view").reportAmbassador.engagementMeasurement.widgetResultByDimensionEngagement
  const [dimensionParent, setDimensionParent] = useState(0)
  const [dataAux, setDataAux] = useState([])

  useEffect(() => {
    initGetData()
  }, [props.idMeasure, props.idDivisionSelected, props.selectedSegment])

  useEffect(() => {
    setDataChart()
  }, [props.dimensionsDrillDown])

  useEffect(() => {
    setDataChart()
  }, [dimensionParent])

  const initGetData = () => {
    const {
      idMeasure,
      getDimensions,
      idDivisionSelected,
      idDivisionParent,
      measureGeneral,
      selectedSegment,
    } = props

    if (!validate.exist(idMeasure) || !validate.exist(measureGeneral)) return

    const params = {
      isHome: true,
      id_measure: idMeasure,
      id_survey_type: measureGeneral.id_survey_type,
      isExclude:
        LOCAL_CHECKBOX_EXCLUDE() === "true" &&
        LOCAL_ISOLATED_METRICS() === "true",
      params: {
        id_measure: idMeasure,
        id_division: idDivisionSelected || idDivisionParent,
        id_segment: selectedSegment,
      },
    }
    if (measureGeneral.is_engagement) {
      params.dimensionType = "Engagement"
      params.is_engagement = true
    } else {
      params.is_engagement = false
    }
    getDimensions(params)
  }

  const setDataChart = () => {
    const { dimensionsDrillDown } = props
    const dataResult = []
    let result = []
    if (dimensionParent === 0) {
      result = [...dimensionsDrillDown]
    } else {
      result = searchTree([...dimensionsDrillDown], dimensionParent)
    }
    result.map((row) => {
      if (row.engagement) {
        return
      }
      let newValue = row.value
      if (!row.anonymity_check.valid) {
        newValue = 100
      }
      dataResult.push({
        name: `${row.name}`,
        impact: row.impact,
        name_sort: truncateText(row.name, 15),
        id_dimension: row.id_dimension,
        id_dimension_parent: row.id_dimension_parent,
        id: row.id,
        id_parent: row.id_parent,
        value: newValue,
        value_org: row.value_org,
        childs: row.childs,
        color: row.color,
        recipients: row.recipients,
        employees: row.employees,
        prev_value: row.prev_value,
        benchmark_value: row.benchmark_value,
        anonymity_check: row.anonymity_check,
      })
    })
    setDataAux(dataResult)
  }

  const renderTitle = () => {
    const {
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      selectedSegment,
    } = props

    let querySegment = ""
    let queryDivision = ""
    let queryParams = ""
    if (idDivisionSelected) {
      queryDivision = `&id_division=${idDivisionSelected}`
    }
    if (selectedSegment) {
      querySegment = `&id_segment=${selectedSegment}`
    }
    if (queryDivision !== "" || querySegment !== "") {
      queryParams = `${"?home=true"}${queryDivision}${querySegment}`
    }
    const link = `/reports/measure/${idMeasure}/divisions/${idDivisionSelected ||
      idDivisionParent ||
      "all"}/dimensions${queryParams}`
    return (
      <div className="WidgetResultByDimensionAmbassador-container-chart-header-container">
        <div className="WidgetResultByDimensionAmbassador-container-chart-header-container-title">
          {intlWidgetResultByDimension.title}
          <PopoverImpact
            container={
              <QuestionCircleFilled
                style={{
                  color: "#D8D8D8",
                  verticalAlign: "baseline",
                  fontSize: "14px",
                  marginLeft: 4,
                  cursor: "pointer",
                }}
              />
            }
          />
        </div>
        <div className="WidgetResultByDimensionAmbassador-container-chart-header-container-link">
          <Link to={link}>{intlWidgetResultByDimension.linkDetails}</Link>
        </div>
      </div>
    )
  }

  const getDataChildren = (data) => {
    if (
      validate.exist(data.childs) &&
      data.childs.length > 0 &&
      data.anonymity_check.valid
    ) {
      setDimensionParent(data.id)
    }
  }

  const getBackData = (idDimensionParent) => {
    const result = searchItemInTree(
      [...props.dimensionsDrillDown],
      idDimensionParent
    )
    setDimensionParent(result.id_parent)
  }

  const renderChart = () => {
    const { measureGeneral, showDimensionBenchmark } = props
    return (
      <ResultByDimensionChart
        isAmbassador
        data={dataAux}
        measureGeneral={measureGeneral}
        getDataChildren={getDataChildren}
        getBackData={getBackData}
        dimensionParent={dimensionParent}
        showDimensionBenchmark={showDimensionBenchmark}
        hideImpact
      />
    )
  }

  const renderContainer = () => {
    if (props.isLoadingDimensions) {
      return (
        <div className="WidgetResultByDimensionAmbassador-container">
          <div className="WidgetResultByDimension-container-chart">
            <div className="loadingSpin">
              <Spin size="large" />
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className="WidgetResultByDimensionAmbassador-container">
        <div className="WidgetResultByDimensionAmbassador-container-chart">
          <div className="WidgetResultByDimensionAmbassador-container-chart-header">
            {renderTitle()}
          </div>
          <div className="WidgetResultByDimensionAmbassador-container-chart-container">
            {renderChart()}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className="WidgetResultByDimensionAmbassador"
      style={{ width: "100%" }}>
      {renderContainer()}
    </div>
  )
}

WidgetResultByDimensionAmbassador.propTypes = {
  typeMeasurement: PropTypes.string,
  idMeasure: PropTypes.number,
  measureTotal: PropTypes.object,
  measureGeneral: PropTypes.object,
  idDivisionSelected: PropTypes.number,
  idDivisionParent: PropTypes.number,
  isLoadingDimensions: PropTypes.bool,
  dimensionsDrillDown: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  divisions: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  getDimensions: PropTypes.func,
  showDimensionBenchmark: PropTypes.bool,
  selectedSegment: PropTypes.number,
}

const mapStateToProps = createStructuredSelector({
  isLoadingDimensions: makeSelectIsLoadingDimensions(),
  dimensionsDrillDown: makeSelectDimensionsDrillDown(),
  divisions: makeSelectDivisions(),
  showDimensionBenchmark: makeSelectShowDimensionBenchmark(),
})

function mapDispatchToProps(dispatch) {
  return {
    getDimensions: (params) => dispatch(getDimensionsWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({
  key: "widgetResultByDimensionAmbassadorV2",
  reducer,
})
const withSaga = injectSaga({ key: "widgetResultByDimensionAmbassadorV2", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(WidgetResultByDimensionAmbassador)
